module.exports = __webpack_public_path__ + "img/health.1553d10d.svg";